import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Modal as RNModal } from 'react-native';
import { FaInfoCircle, FaTimes } from 'react-icons/fa';
import { useTheme } from '../theme/ThemeContext';

let THEME = {};
const getStyles = () => StyleSheet.create({
    container: {
        marginLeft: 8,
    },
    iconButton: {
        padding: 4,
    },
    backdrop: {
        flex: 1,
        backgroundColor: THEME.overlay,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    tooltip: {
        width: '85%',
        maxWidth: 320,
        backgroundColor: THEME.modalBg,
        borderRadius: 12,
        padding: 16,
        borderWidth: 1,
        borderColor: THEME.border,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 10 },
        shadowOpacity: 0.5,
        shadowRadius: 20,
        elevation: 10,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: THEME.border,
    },
    title: {
        color: THEME.textMuted,
        fontSize: 10,
        fontWeight: '700',
        letterSpacing: 1,
    },
    closeButton: {
        padding: 4,
    },
    content: {
        color: THEME.textPrimary,
        fontSize: 13,
        lineHeight: 20,
        fontFamily: 'system-ui, -apple-system, sans-serif',
    }
});
let styles = getStyles();

const InfoTooltip = ({ text, title = "ANALYSIS REASONING" }) => {
    const [visible, setVisible] = useState(false);
    const { theme } = useTheme();
    Object.assign(THEME, theme);
    styles = getStyles();

    if (!text) return null;

    return (
        <View style={styles.container}>
            <TouchableOpacity onPress={() => setVisible(true)} style={styles.iconButton}>
                <FaInfoCircle size={12} color={theme.textMuted} />
            </TouchableOpacity>

            <RNModal
                transparent={true}
                visible={visible}
                animationType="fade"
                onRequestClose={() => setVisible(false)}
            >
                <TouchableOpacity
                    style={styles.backdrop}
                    activeOpacity={1}
                    onPress={() => setVisible(false)}
                >
                    <View style={styles.tooltip} onStartShouldSetResponder={() => true}>
                        <View style={styles.header}>
                            <Text style={styles.title}>{title}</Text>
                            <TouchableOpacity onPress={() => setVisible(false)} style={styles.closeButton}>
                                <FaTimes size={12} color={theme.textMuted} />
                            </TouchableOpacity>
                        </View>
                        <Text style={styles.content}>{text}</Text>
                    </View>
                </TouchableOpacity>
            </RNModal>
        </View>
    );
};


export default InfoTooltip;
